import {Component} from '@angular/core';
import {MAIL_SENT_LOGO, RAMERAMECOID_LOGO} from '../../constants/common.constant';

@Component({
  selector: 'app-page-mail-sent',
  templateUrl: './mail-sent.page.html',
})
export class MailSentPageComponent{
  public logo = RAMERAMECOID_LOGO;
  public mailSentLogo = MAIL_SENT_LOGO;
}
